import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class PorosityNCalculationMethodModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (PorosityNCalculationMethodModel._instance == null) PorosityNCalculationMethodModel._instance = new PorosityNCalculationMethodModel(authManager);
        return PorosityNCalculationMethodModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'geo-sections/porosity-n-calculation-methods', 'geo-sections/porosity-n-calculation-methods/codelist');

        this.entityName = 'geo-sections.PorosityNCalculationMethod';
        this.privileges = {
            create: [["#admin"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["#admin"]],
            delete: [["#admin"]],
        };

        this.label = 'Porosity N Calc Method';
        this.setLabel = 'Porosity N Calc Methods';

        this.browser = {
            name: 'default-geo-sections-porosityncalculationmethod-browser',
            moduleName: 'default-geo-sections-porosityncalculationmethod-browser',
            moduleTitle: 'Porosity N Calc Methods',
            moduleStateSlotName: 'default-geo-sections-porosityncalculationmethod-browser',
        };

        this.editor = {
            name: 'default-geo-sections-porosityncalculationmethod-editor',
            moduleName: 'default-geo-sections-porosityncalculationmethod-editor',
            moduleTitle: 'Porosity N Calc Method',
            moduleStateSlotName: 'default-geo-sections-porosityncalculationmethod-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
